import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO, FAQ_ITEMS } from '../mock';

export const SEOHead = () => {
  const schemaLocalBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.dein-gutachten-direkt.de/#business",
    "name": COMPANY_INFO.name,
    "description": "Unabhängige Unfallgutachten bundesweit. Professionelle Schadensbegutachtung direkt vor Ort durch qualifizierte Sachverständige.",
    "url": "https://www.dein-gutachten-direkt.de",
    "telephone": "+494101847116",
    "priceRange": "Kostenübernahme durch Versicherung in der Regel möglich",
    "image": {
      "@type": "ImageObject",
      "url": "https://customer-assets.emergentagent.com/job_gutachten-preview/artifacts/gusc9edr_image.png",
      "width": 200,
      "height": 60,
      "caption": "Dein Gutachten Direkt Logo",
      "creditText": "Dein Gutachten Direkt",
      "creator": {"@type": "Organization", "name": "Dein Gutachten Direkt"},
      "copyrightNotice": "© 2026 Dein Gutachten Direkt"
    },
    "logo": {
      "@type": "ImageObject",
      "url": "https://customer-assets.emergentagent.com/job_gutachten-preview/artifacts/gusc9edr_image.png",
      "width": 200,
      "height": 60
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": COMPANY_INFO.address.street,
      "addressLocality": COMPANY_INFO.address.city,
      "postalCode": COMPANY_INFO.address.zip,
      "addressRegion": COMPANY_INFO.address.state,
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "53.65",
      "longitude": "9.85"
    },
    "areaServed": [
      { "@type": "Country", "name": "Deutschland" },
      { "@type": "State", "name": "Schleswig-Holstein" },
      { "@type": "City", "name": "Hamburg" },
      { "@type": "City", "name": "Rellingen" }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "foundingDate": "2014",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "mehrere Sachverständige"
    },
    "knowsAbout": [
      "Unfallgutachten",
      "Kfz-Schadensbewertung", 
      "Wertminderung",
      "Nutzungsausfall",
      "Fahrzeugbegutachtung"
    ]
  };

  const schemaService = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Unfallgutachten",
    "provider": {
      "@type": "LocalBusiness",
      "name": COMPANY_INFO.name
    },
    "areaServed": { "@type": "Country", "name": "Deutschland" },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Gutachten-Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Unfallgutachten",
            "description": "Unabhängiges Gutachten nach Verkehrsunfall"
          }
        }
      ]
    }
  };

  const schemaFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_ITEMS.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Unfallgutachten bundesweit | Dein Gutachten Direkt Rellingen</title>
      <meta name="title" content="Unfallgutachten bundesweit | Dein Gutachten Direkt Rellingen" />
      <meta name="description" content="Unabhängiges Unfallgutachten direkt vor Ort – bundesweit. Schnelle Terminvergabe, professionelle Begutachtung durch qualifizierte Sachverständige." />
      <meta name="keywords" content="Unfallgutachten, Gutachter Rellingen, Unfallgutachter bundesweit, mobiles Gutachten, unabhängiges Gutachten, Hamburg, Schleswig-Holstein" />
      
      {/* Canonical URL */}
      <link rel="canonical" href="https://www.dein-gutachten-direkt.de/" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.dein-gutachten-direkt.de/" />
      <meta property="og:title" content="Unfallgutachten bundesweit | Dein Gutachten Direkt" />
      <meta property="og:description" content="Unabhängiges Unfallgutachten direkt vor Ort – bundesweiter Service mit Hauptsitz in Rellingen" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.dein-gutachten-direkt.de/" />
      <meta property="twitter:title" content="Unfallgutachten bundesweit | Dein Gutachten Direkt" />
      <meta property="twitter:description" content="Unabhängiges Unfallgutachten direkt vor Ort" />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaLocalBusiness)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(schemaService)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(schemaFAQ)}
      </script>
    </Helmet>
  );
};